import GenDuo from '../public/genduo'
import H2Title from '../public/h2Title'
import videoImg from '../../images/home/VIDEO.png'
import useMediaQuery from '../../hooks/useMediaQuery'
import { Col, Row } from 'antd'
import { BASE_URL } from '../../api/api'
import bofang from '../../images/bofang.png'
import NavLink from '../navLink'

const Zjxc = ({ liveList }) => {
  const isMobile = useMediaQuery()
  const { channel, list = [] } = liveList || {}
  const { name, id } = channel || {}
  const [list1, list2, list3, list4] = list || []

  return (
    <div className="w-full mt-[60px] px-5 lg:px-0">
      <div className="flex justify-center lg:justify-between items-center">
        <p className="hidden lg:block"></p>
        <H2Title title={name} />
        <GenDuo href={`/zjxc/channel_id/${id}`} className="hidden lg:block" />
      </div>
      <div className="flex flex-col lg:flex-row justify-between mt-8">
        <div className="flex">
          <img
            className="hidden lg:block"
            src={videoImg}
            style={{ width: 90, height: 440 }}
            alt=""
          />
          <div className="w-full relative">
            <img
              style={{ width: isMobile ? '100%' : 586, height: 440 }}
              src={`${BASE_URL}${list1?.title1 || ''}`}
              alt=""
            />
            <NavLink to={`/spbf/channel_id/${list1?.id}`}>
              <img
                className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
                style={{ width: 123, height: 123 }}
                src={bofang}
                alt=""
              />
            </NavLink>
          </div>
        </div>
        {isMobile ? (
          <div>
            <Row className="mt-8" gutter={24}>
              <Col span={8}>
                <NavLink to={`/spbf/channel_id/${list2?.id}`}>
                  <img src={`${BASE_URL}${list2?.image || ''}`} style={{ height: 142 }} alt="" />
                </NavLink>
              </Col>
              <Col span={8}>
                <NavLink to={`/spbf/channel_id/${list3?.id}`}>
                  <img src={`${BASE_URL}${list3?.image || ''}`} style={{ height: 142 }} alt="" />
                </NavLink>
              </Col>
              <Col span={8}>
                <NavLink to={`/spbf/channel_id/${list4?.id}`}>
                  <img src={`${BASE_URL}${list4?.image || ''}`} style={{ height: 142 }} alt="" />
                </NavLink>
              </Col>
            </Row>
            <div className="flex lg:hidden justify-center">
              <GenDuo
                href={`/zjxc/channel_id/${id}`}
                className="mx-auto mt-[30px] bg-[#0189D5] px-6 py-2 rounded-xl text-white"
              />
            </div>
          </div>
        ) : (
          <div className="ml-5">
            <NavLink to={`/spbf/channel_id/${list2?.id}`}>
              <img
                src={`${BASE_URL}${list2?.image || ''}`}
                style={{ width: 500, height: 232 }}
                alt=""
              />
            </NavLink>
            <div className="flex">
              <NavLink to={`/spbf/channel_id/${list3?.id}`}>
                <img
                  style={{ width: 250 }}
                  src={`${BASE_URL}${list3?.image || ''}`}
                  className="h-[207px]"
                  alt=""
                />
              </NavLink>
              <NavLink to={`/spbf/channel_id/${list4?.id}`}>
                <img
                  style={{ width: 250 }}
                  src={`${BASE_URL}${list4?.image || ''}`}
                  className="h-[207px]"
                  alt=""
                />
              </NavLink>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Zjxc
